import Chip from '@mui/material/Chip';
import { colours } from '../theme';

/** A choice among a few (a month, a number of stickers): black when chosen, a little larger under the mouse. */
export function ChoiceChip({ label, selected, onClick }: { label: string; selected: boolean; onClick(): void }) {
  return (
    <Chip
      label={label}
      onClick={onClick}
      variant={selected ? 'filled' : 'outlined'}
      aria-pressed={selected}
      sx={{
        fontWeight: 500,
        transition: 'transform 120ms ease-out',
        ...(selected
          ? { bgcolor: colours.nearBlack, color: colours.white, borderColor: colours.nearBlack, '&:hover': { bgcolor: colours.nearBlack, transform: 'scale(1.06)' } }
          : { borderColor: colours.hairline, color: colours.nearBlack, '&:hover': { bgcolor: colours.white, borderColor: colours.nearBlack, transform: 'scale(1.06)' } }),
        // Last, so it wins over the hover above.
        '@media (prefers-reduced-motion: reduce)': { transition: 'none', '&:hover': { transform: 'none' } },
      }}
    />
  );
}
